import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/auth-context'

interface ProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) {
    // Redirect to unauthorized page, preserving the attempted location
    return <Navigate to='/unauthorized' state={{ from: location }} replace />
  }

  return <>{children}</>
}
